import React, { useCallback, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HeadlineGroup } from '../types';
import { useStore } from '../store/index';
import { FloatingActionPanel } from '../components/shared/FloatingActionPanel';
import { ResizablePanels } from '../layout';
import { DataProvider } from '../db/ShapeConnector';

function AuthenticatedApp() {
  const {
    setSelectedHeadlineGroup,
    setSelectedTab,
    error,
    isLoading
  } = useStore();
  
  // Handler for when a headline group is selected
  const handleHeadlineGroupSelect = useCallback((group: HeadlineGroup) => {
    setSelectedHeadlineGroup(group);
  }, [setSelectedHeadlineGroup]);

  // Update selected tab based on route
  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('/studio')) {
      setSelectedTab('studio');
    } else {
      setSelectedTab('stream');
    }
  }, [window.location.pathname, setSelectedTab]);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <DataProvider>
      <div className="App w-full">
        <Routes>
          <Route 
            path="/stream" 
            element={
              <ResizablePanels 
                onHeadlineGroupSelect={handleHeadlineGroupSelect}
              />
            } 
          />
          <Route 
            path="/studio" 
            element={
              <ResizablePanels 
                onHeadlineGroupSelect={handleHeadlineGroupSelect}
              />
            } 
          />
          <Route path="/" element={<Navigate to="/stream" replace />} />
        </Routes>

        {/* Add FloatingActionPanel */}
        <FloatingActionPanel />
      </div>
    </DataProvider>
  );
}

export default AuthenticatedApp; 